<template>
    <b-modal
        id="add-survey"
        :title="$t('management.add_survey')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        ok-variant="primary"
        size="md-custom"
        modal-class="apprentice-default-modal"
        @ok="onOk"
        @show="onShow">
        <div>
            <b-form-group
                class="group-input-title"
                :label="$t('management.survey_name')"
                label-for="module-title-input">
                <b-form-input
                    class="apprentice-primary-input"
                    v-model="name"></b-form-input>
            </b-form-group>

            <b-form-group
                class="group-input-title"
                :label="$t('management.choose_main_group')"
                label-for="module-title-input">
                <design-2021-apprentice-multiselect-component
                    v-model="selectedLasMainGroups"
                    label="name"
                    :options="lasMainGroupsIn">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-magagement-profile-choice-add-survey-modal-component',
    props: ['lasMainGroupsIn'],
    data() {
        return {
            name: null,
            selectedLasMainGroups: [],
        };
    },
    methods: {
        onOk() {
            this.alert.saving();

            const data = {
                name: this.name,
                las_main_group_ids: this.selectedLasMainGroups.map((item) => item.id),
            };

            this.axios.post(this.routes.managementProfileChoiceSurvey(), data).then(
                (response) => {
                    this.$emit('survey-added', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        onShow() {
            this.name = null;
            this.selectedLasMainGroups = [];
        },
    },
};
</script>

<style scoped></style>
